export default class Money {
  amount;
  currency;
}
